// Which desktop programs can open which files, plus the person's "Always use this" choices.
const EXT = {
  viewer: ["*"],
  word: ["docx", "cdoc"],
  sheets: ["xlsx", "xls", "csheet"],
  pdfcraft: ["pdf", "docx", "tif", "tiff", "jpg", "jpeg", "png", "gif", "bmp"],
  gridcraft: ["xlsx", "xls", "csv", "tsv", "ods"],
  wordcraft: ["docx", "doc", "odt", "rtf", "txt", "md", "html", "htm"],
  deckcraft: ["pptx", "ppt", "odp"],
  designcraft: ["pptx", "png", "jpg", "jpeg", "svg", "webp"],
  photocraft: ["png", "jpg", "jpeg", "webp", "gif", "bmp", "tif", "tiff", "psd", "kra", "heic", "avif"],
  vectorcraft: ["svg", "pdf", "ai", "eps"],
  lightcraft: ["jpg", "jpeg", "png", "tif", "tiff", "dng", "cr2", "cr3", "nef", "arw", "raf", "orf", "rw2", "heic"],
  figcraft: ["fig", "svg", "png", "jpg", "jpeg"],
  filmcraft: ["mp4", "mov", "webm", "mkv", "m4v", "avi"],
  effectcraft: ["mp4", "mov", "webm", "png", "jpg", "jpeg"],
  soundcraft: ["wav", "mp3", "flac", "ogg", "m4a", "aac", "aiff", "aif"],
  cadcraft: ["dxf", "dwg", "svg", "stl"],
  texturecraft: ["png", "jpg", "jpeg", "webp"],
};
const KEY = "desk_open_with";

export const VIEWER = { title: "File viewer", color: "text-slate-500" };
export const extOf = (name = "") => (name.includes(".") ? name.split(".").pop().toLowerCase() : "");
export const OPENABLE = Object.keys(EXT);

export const suggestedFor = (name) => {
  const ext = extOf(name);
  return OPENABLE.filter((k) => k !== "viewer" && EXT[k].includes(ext));
};

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
export const savedDefault = (name) => read()[extOf(name)] || null;
export const saveDefault = (name, app) => {
  const ext = extOf(name);
  if (!ext) return;
  localStorage.setItem(KEY, JSON.stringify({ ...read(), [ext]: app }));
};

// Opens a file in the chosen program (the desktop listens for "desk-open-app").
export const openFileWith = (app, node) => {
  const file = { id: node.id, name: node.name };
  const detail = app === "viewer" ? { app: "files", props: { initialPreviewId: node.id } } : { app, props: { file } };
  window.dispatchEvent(new CustomEvent("desk-open-app", { detail }));
};

// Double-click: the person's saved choice wins; returns false when there is none.
export const openWithDefault = (node) => {
  const app = savedDefault(node.name);
  if (!app || !OPENABLE.includes(app)) return false;
  openFileWith(app, node);
  return true;
};
